import React from 'react'
import { useFunnel } from '../../contexts/FunnelContext'
import { CheckCircle, User, Mail, Calendar } from 'lucide-react'

const WelcomeMemberPage: React.FC = () => {
  const { state } = useFunnel()
  const customerName = state.fullName || 'Valued Member'

  return (
    <div style={{ backgroundColor: 'rgb(246, 246, 241)', minHeight: '100vh', padding: '2rem 0' }}>
      <div className="mx-auto max-w-3xl px-8">
        <div className="bg-white p-8 rounded-xl text-center mb-8">
          <CheckCircle className="w-20 h-20 mx-auto mb-4" style={{ color: '#145F6B' }} />
          <h1 className="text-4xl font-bold mb-4" style={{ color: '#145F6B' }}>
            Welcome to the Club, {customerName}!
          </h1>
          <p className="text-lg" style={{ color: 'rgb(76,76,75)' }}>
            We are thrilled to have you as a Founding Member. Your home is now under the proactive
            care of the Hudson team. Get ready to experience effortless homeownership.
          </p>
        </div>

        <div className="bg-white p-8 rounded-xl border-2" style={{ borderColor: '#145F6B' }}>
          <h2 className="text-2xl font-semibold mb-6" style={{ color: 'rgb(15,15,15)' }}>
            Your Premium Experience Begins Now
          </h2>

          <div className="space-y-6">
            <div className="flex items-start gap-4">
              <div
                className="w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0"
                style={{ backgroundColor: 'rgb(246, 246, 241)' }}
              >
                <User className="w-6 h-6" style={{ color: '#145F6B' }} />
              </div>
              <div>
                <h3 className="text-lg font-semibold mb-2" style={{ color: 'rgb(15,15,15)' }}>
                  1. Dedicated Home Director
                </h3>
                <p className="text-base" style={{ color: 'rgb(76,76,75)' }}>
                  Your personal Home Director will contact you within one business day to introduce
                  themselves and schedule your initial MyHome Blueprint™ assessment.
                </p>
              </div>
            </div>

            <div className="flex items-start gap-4">
              <div
                className="w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0"
                style={{ backgroundColor: 'rgb(246, 246, 241)' }}
              >
                <Mail className="w-6 h-6" style={{ color: '#145F6B' }} />
              </div>
              <div>
                <h3 className="text-lg font-semibold mb-2" style={{ color: 'rgb(15,15,15)' }}>
                  2. Member Portal Access
                </h3>
                <p className="text-base" style={{ color: 'rgb(76,76,75)' }}>
                  You will receive a separate email with a link to set up your password for the
                  exclusive Hudson My Home member portal.
                </p>
              </div>
            </div>

            <div className="flex items-start gap-4">
              <div
                className="w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0"
                style={{ backgroundColor: 'rgb(246, 246, 241)' }}
              >
                <Calendar className="w-6 h-6" style={{ color: '#145F6B' }} />
              </div>
              <div>
                <h3 className="text-lg font-semibold mb-2" style={{ color: 'rgb(15,15,15)' }}>
                  3. Enjoy the Peace of Mind
                </h3>
                <p className="text-base" style={{ color: 'rgb(76,76,75)' }}>
                  Relax. We'll take it from here. Your first monthly check-up is already being
                  scheduled.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default WelcomeMemberPage

